
































import InfoBox from "@/lib/components/InfoBox.vue";
import ItemDescriptions from "@/lib/partials/shared/ItemDescriptions.vue";
import { tokenProvider } from "@/lib/TokenProvider";

import {
  alertMessage,
  isEmpty,
  qsParams,
  setHighestPriorityCustomerApplication,
} from "@/lib/utilities";
import { setCookie, CookieNames } from "@/lib/utilities/cookieUtilities";
import { OverallStatusNames } from "@/lib/utilities/overallStatusNames";
import Vue from "vue";

export const SECONDARY_DESCRIPTIONS = [
  {
    title: "Leverandører",
    key: "supplierList",
    componentName: "suppliers",
    fields: [
      { key: "role", label: "Rolle", thClass: "pl-0", tdClass: "pl-0" },
      { key: "name", label: "Navn" },
      { key: "jobTitle", label: "Titel" },
      { key: "phone", label: "Tlf. nr." },
      { key: "email", label: "E-mail" },
    ],
  },
  {
    title: "Vejledninger for kunder",
    key: "document",
    componentName: "agreementDocuments",
  },
  {
    title: "Vejledninger for leverandører",
    key: "document",
    componentName: "agreementDocuments",
  },
  {
    title: "Aftaledokumenter",
    key: "document",
    componentName: "agreementDocuments",
  },
  {
    title: "Ekspertgruppe",
    key: "projectGroup",
    componentName: "expertGroup",
    fields: [
      {
        key: "customerName",
        label: "Organisation",
        thClass: "pl-0",
        tdClass: "pl-0",
      },
      { key: "shoppingCommunity[0].name", label: "Indkøbsfællesskab" },
    ],
  },
  {
    title: "Kunder der kan anvende aftalen",
    key: "customers",
    componentName: "customers",
    fields: [
      {
        key: "companyname",
        label: "Kunde",
        tdClass: "text-nowrap",
      },
      {
        key: "applicationLabel",
        label: "Anvendelse",
        tdClass: "text-nowrap",
      },
      {
        key: "connectiontext",
        label: "Anvendelsestekst",
        tdClass: "w-100",
      },
    ],
  },
];

interface Data {
  id: string;
  documentId: string;
  item: {} | null;
  agreementType: string;
  infoDescription: string;
}

export default Vue.extend({
  components: { InfoBox, ItemDescriptions },
  props: {
    descriptionsTitle: {
      type: String,
      default: "",
    },
    descriptionsDescription: {
      type: String,
      default: "",
    },
  },
  data(): Data & { SECONDARY_DESCRIPTIONS: any[] } {
    return {
      id: "",
      documentId: "",
      item: null,
      agreementType: "",
      infoDescription: "",
      SECONDARY_DESCRIPTIONS,
    };
  },
  created() {
    this.id = qsParams().id;
    this.documentId = qsParams().documentId;
    this.fetchAndSetAgreementAPIData();

    // We set the jwt token as a cookie, to enable the Umbraco endpoint for downloading documents to access the jwt token
    setCookie(CookieNames.jwtToken, tokenProvider.token, "/");
  },
  methods: {
    async fetchAndSetAgreementAPIData() {
      try {
        var agreement = await this.$api.AgreementsRepository.get(this.id);
        const agreementDescriptions =
          await this.$api.AgreementsRepository.getDescription(this.id);
        this.$root.$data.itemDescriptions = agreementDescriptions;
        if (this.redirectToTenderPage(agreement)) return;
        var iteAgreement = agreement;
        if (iteAgreement) {
          if (iteAgreement.customerApplication !== undefined) {
            setHighestPriorityCustomerApplication(this, iteAgreement);
          } else {
            iteAgreement[this.$config.agreement.application.activeApplication] =
              null;
          }
        }

        const infoDescriptionRaw = agreementDescriptions.find(
          (x: { agreementDescriptionName: string }) =>
            x.agreementDescriptionName === "Særlig information om aftalen"
        );
        this.infoDescription =
          infoDescriptionRaw !== undefined
            ? infoDescriptionRaw.agreementDescriptionText
            : "";

        this.item = iteAgreement;
        this.$root.$data.item = this.item;
        this.setAgreementType(this.item);
      } catch (err) {
        alertMessage(this);
      }
    },
    redirectToTenderPage(response: any): boolean {
      var { statusField, tenderStatus, tenderPage } = {
        statusField: "overallStatusName",
        tenderStatus: OverallStatusNames.Upcoming,
        tenderPage: "/udbud/se-udbud/",
      };

      if (response[statusField] === tenderStatus) {
        window.location.href = `${tenderPage}?id=${this.id}${
          this.documentId !== undefined ? "&documentId=" + this.documentId : ""
        }`;
        return true;
      }
      return false;
    },
    setAgreementType(item: any) {
      if (item === null) return;

      // TODO: FIX This should be handled by backend API
      if (item.mainAgreementName) {
        this.$root.$data.agreementType = this.agreementType = "subAgreement";
      } else if (!isEmpty(item.subAgreement)) {
        this.$root.$data.agreementType = this.agreementType =
          "mainAgreementWithSubAgreements";
      } else {
        this.$root.$data.agreementType = this.agreementType = "mainAgreement";
      }
    },
    shouldRender(component: string) {
      let hidden: string[] = [];
      switch (this.agreementType) {
        case "mainAgreement":
          hidden = ["agreement-item-sub-agreements"];
          break;
        case "mainAgreementWithSubAgreements":
          hidden = ["timeline", "status"];
          break;
        case "subAgreement":
          hidden = ["agreement-item-sub-agreements"];
          break;
      }
      if (hidden.includes(component)) {
        return false;
      }

      return true;
    },
  },
});
